import { Cake, Heart, Gift, Trophy, Star, PartyPopper, Award, Sparkle, Candy } from 'lucide-react'

// Backend sends semantic keys ("occasion_type", "icon"), not display
// text or emoji — this is the one place that turns those keys into UI.

export const OCCASION_LABELS = {
    birthday: 'Birthday',
    anniversary: 'Wedding Anniversary',
    child_birthday: "Child's Birthday",
    business_anniversary: 'Business Anniversary',
}

export const prettifyOccasionType = (occasionType) =>
    OCCASION_LABELS[occasionType] ||
    (occasionType || '').replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())

export const ICON_EMOJI_MAP = {
    cake: '🎂',
    heart: '💍',
    rings: '💍',
    balloon: '🎈',
    trophy: '🏆',
    gift: '🎁',
    'party-popper': '🎉',
    award: '🏅',
    sparkle: '✨',
    candy: '🍬',
}

export const emojiForIcon = (icon) => ICON_EMOJI_MAP[icon] || '🎉'

// Fallback for responses that only give occasion_type, no icon key
// (e.g. sm_get_recent_activity) — separate from ICON_EMOJI_MAP since
// these are two different keyspaces (occasion type vs. icon key).
export const OCCASION_TYPE_EMOJI = {
    birthday: '🎂',
    anniversary: '💍',
    child_birthday: '🎈',
    business_anniversary: '🏆',
}

export const emojiForOccasionType = (occasionType) => OCCASION_TYPE_EMOJI[occasionType] || '🎉'

// Every icon key the backend is known to send, mapped to a real lucide
// component — used where a crisp icon reads better than an emoji (e.g.
// the client profile's Special Moments tab). "rings"/"balloon" have no
// dedicated lucide icon, so they fall back to the closest visual match.
export const ICON_COMPONENT_MAP = {
    cake: Cake,
    heart: Heart,
    rings: Heart,
    gift: Gift,
    trophy: Trophy,
    star: Star,
    'party-popper': PartyPopper,
    balloon: PartyPopper,
    award: Award,
    sparkle: Sparkle,
    candy: Candy,
}

export const getIconComponent = (icon) => ICON_COMPONENT_MAP[icon] || Sparkle

// Curated set of real lucide icon keys for pickers (e.g. "create custom
// occasion") — sm_create_custom_occasion expects one of these, not an emoji.
export const CUSTOM_OCCASION_ICON_OPTIONS = [
    'cake', 'heart', 'gift', 'trophy', 'star', 'party-popper', 'award', 'sparkle', 'candy',
].map((key) => ({ key, label: prettifyOccasionType(key.replace('-', '_')), Icon: ICON_COMPONENT_MAP[key] }))
